import type { IRawData } from "app/pages/industry-analysis/players/table/types";

export interface IMarketPlayersState {
    rawData: IRawData;
    risingAndDecliningRawData: IRawData;
    isLoading: boolean;
}

export enum EScrollTo {
    QUADRANT = "quadrant",
    MARKET_SHARES = "marketShares",
}
